import ImageCardGrid from './ImageCardGrid';
import React from 'react';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param previewImage : Image source (required).
 * @param classNameWH: Styling class for image width and height
 * @param children: components to render
 * @param head: If provided, it replaces the default header content (optional)
 * @param selected: Applies selected state styles automatically using error background and border helper classes.
 */
const CustomCardGridGeneral = ({previewImage, classNameWH, children, head=null, headImage=null, className='', selected = false, }) => {

     const selectedClass = selected ? 'background-error-code-50 border-full-error-code-400': '';

    return(
        <div  className={`panel-grid-general d-flex flex-column justify-content-center align-items-center  ${selectedClass}`} >
            {/* HEAD */}
            {head !== null?
                head :
                <div className='img-container img-background-shades-100 d-flex flex-column p-3 gap-2 flex-fill align-self-stretch'>
                    { headImage != null && headImage }
                    <div className='d-flex justify-content-center align-items-center gap-2 align-self-stretch'>
                        <ImageCardGrid preview={previewImage} classNameWH={classNameWH} />
                    </div>
                </div>
            }

            {/* BODY */}
            <div className='d-flex flex-column align-items-start gap-3 align-self-stretch p-16px'>
                {/* CONTENT AND FOOTER */}
                {children}
            </div>
        </div>
    )
}

export default CustomCardGridGeneral
